import { render, staticRenderFns } from "./LivestreamAnnouncementAddEdit.vue?vue&type=template&id=29aad6b4&scoped=true&"
import script from "./LivestreamAnnouncementAddEdit.vue?vue&type=script&lang=js&"
export * from "./LivestreamAnnouncementAddEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29aad6b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29aad6b4')) {
      api.createRecord('29aad6b4', component.options)
    } else {
      api.reload('29aad6b4', component.options)
    }
    module.hot.accept("./LivestreamAnnouncementAddEdit.vue?vue&type=template&id=29aad6b4&scoped=true&", function () {
      api.rerender('29aad6b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/LiveStream/Announcements/LivestreamAnnouncementAddEdit.vue"
export default component.exports